import { EnterOutlined } from "@ant-design/icons";
import { Add, Delete } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Checkbox, Input as InputArea } from "antd";
import TextArea from "antd/lib/input/TextArea";
import AnimatedCheckMark from "components/AnimatedCheckMark";
import AnimatedCross from "components/AnimatedCross";
import Loading from "components/Loading";
import TextReader from "components/Reader";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import { get, map } from "lodash";
import React, { useCallback, useMemo, useRef } from "react";
import { useVoabPermissionForUser } from "store/organizations/selectors";
import { useUserProfileConfig } from "store/users/selectors";
import styled from "styled-components";
import { dispalayRole } from "utils/methods/math";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const CogantesTable = (props) => {
  const {
    getBooksVocab,
    currentUser,
    showWordLoader,
    showWordEnglishLoader,
    tabSelector,
    non_native,
    isExam,
    selectedWordCogantes,
    vocLoader,
    isCognatesAllowedForBookGroup,
    selectedModeDataLength,
    itemsPerPage,
    currentPage,
    setCurrentPage,
    selectedModeData,
  } = props?.states || {};
  const {
    handleAddVocData,
    callVocAI,
    editDataProperty,
    stopAudio,
    addNewItem,
    setDeleteModal,
    setLoading,
    handleUpdateData,
    handleCheckboxChangeForCogantes,
  } = props?.funcObj || {};
  const showAlert = useAlert();
  const prevValueRef = useRef("");
  const handleFocus = (value) => {
    prevValueRef.current = value;
  };
  const vocab_permission = useVoabPermissionForUser()
  const is_cognet_block_edit = useMemo(() => currentUser.role == "student" && vocab_permission && vocab_permission.cognats, [vocab_permission, currentUser])
  const disbledInput = useCallback(
    (createdBy, spanishWord) => {
      if (!spanishWord || tabSelector?.type === 'my_student_cog') {
        return true;
      }
      if (currentUser?.role === "owe_admin") {
        return false;
      } else if (currentUser?.role === "teacher") {
        return createdBy === "owe_admin";
      } else if (currentUser?.role === "student") {
        return createdBy === "owe_admin" || createdBy === "teacher" || is_cognet_block_edit;
      }
    },
    [currentUser, tabSelector , is_cognet_block_edit ]
  );
  const { isAiPermissionEnabled } = useUserProfileConfig();
  const handleAIBeforeAddNewItem = () => {
    if (!isAiPermissionEnabled) {
      showAlert('Please enable AI permission to add new item.', 'error');
      return true;
    }
    return false;
  }
    const handleForDistrictAdmin = () => {
        if (currentUser.role === 'admin') {
          showAlert('Please login as teacher!', 'error')
            return true;
        }
        return false;
    }

  return (
    <>
      <StyledTable border className="vocabulTable">
        <StyledHeader className="vocabulHeadTh">
          {currentUser?.role === "teacher" && !isExam ? (
            <StyledTh style={{ maxWidth: 250 }}>Check</StyledTh>
          ) : (
            ""
          )}
          <StyledTh style={{ maxWidth: 250 }}>Cognate</StyledTh>
          <StyledTh>Word (Spanish)</StyledTh>
          <StyledTh style={{ minWidth: 200 }}>Word (English)</StyledTh>
          <StyledTh style={{ minWidth: 200 }}>Type</StyledTh>
          <StyledTh style={{ minWidth: 200 }}>Explanation</StyledTh>
          <StyledTh style={{ minWidth: 200 }}>Sentence in Spanish</StyledTh>
          <StyledTh style={{ minWidth: 200 }}>Sentence in English</StyledTh>
          <StyledTh>Actions</StyledTh>
        </StyledHeader>
        {map(getBooksVocab, (value, k) => {
          let data = get(value, "data", "");
          return (
            <tr className="vocabulHeadTr vocIcons" key={k}>
              {/*  *** for  check **** */}
              {currentUser?.role === "teacher" && !isExam && (
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Checkbox
                      onChange={(e) =>
                        handleCheckboxChangeForCogantes(e.target.checked, value)
                      }
                      checked={selectedWordCogantes.some(
                        (item) => item.id === value.id
                      )}
                    />
                  </div>
                </td>
              )}

              <td style={{ textAlign: "center" }}>
                {data?.word_spanish && (
                  <div className="flex items-center justify-center">
                    {data?.type ? (
                      <AnimatedCheckMark animation={false} />
                    ) : (
                      <AnimatedCross animation={false} />
                    )}
                  </div>
                )}
              </td>

              {/*  *** for  word  spanish**** */}
              <td style={{ textAlign: "center" }}>
                {value?.isEditable === true && !showWordEnglishLoader ? (
                  <div className='vocabInput'>
                    <InputArea
                      onPressEnter={() => {
                        if (!showWordLoader) {
                          callVocAI("spanish");
                        }
                      }}
                      onChange={(d) => {
                        handleAddVocData("word", d.target.value.trimStart());
                      }}
                      placeholder="Word Spanish"
                      autoSize
                      autoFocus
                      style={{
                        backgroundColor: "transparent",
                        borderColor: "transparent",
                        color: "white",
                        fontWeight: 200,
                        width: getBooksVocab?.length === 1 && "100%",
                      }}
                    />
                    <div style={{ position: "absolute", top: 6, right: 4 }}>
                      {showWordLoader ? (
                        <Loading size={17} />
                      ) : (
                        <EnterOutlined
                          disabled={showWordLoader}
                          onClick={() => {
                            if (!showWordLoader) {
                              callVocAI();
                            }
                          }}
                          style={{ fontSize: "25px" }}
                        />
                      )}
                    </div>
                  </div>
                ) : (
                  <>
                    <TextReader
                      stopAudio={stopAudio}
                      text={get(data, "word_spanish", "")}
                      language={"es-ES"}
                      style={{ float: "right" }}
                    />

                    <TextArea
                      disabled={
                        value?.created_by === "owe_admin" ||
                        currentUser?.role === "student" ||
                        value?.created_by === "teacher" ||
                        tabSelector?.type === "my_student_cog"
                      }
                      value={
                        currentUser?.role === "owe_admin"
                          ? (() => {
                            const word = get(data, "word_spanish", "").trim();
                            if (!word) return "";
                              const cleanWord = word.replace(/\s*\((Admin|Teacher)\)\s*$/, "");
                              return currentUser?.role === "owe_admin"
                                ? `${cleanWord} (Admin)`
                                : cleanWord
                            })()
                          : get(data, "word_spanish", "")
                      }
                      onChange={(d) =>
                        editDataProperty(
                          value.id,
                          d.target.value.trimStart(),
                          "word_spanish"
                        )
                      }
                      placeholder="word spanish"
                      autoSize
                      autoFocus
                      style={{
                        width: 150,
                        backgroundColor: "transparent",
                        borderColor: "transparent",
                        color: "white",
                        fontWeight: 200,
                      }}
                    />
                  </>
                )}
              </td>

              {/*  *** for  word_english **** */}
              <td style={{ textAlign: "center" }}>
                {non_native ? (
                  <>
                    {value?.isEditable === true && !showWordLoader ? (
                      <div className='vocabInput'>
                        <InputArea
                          onPressEnter={() => {
                            if (!showWordEnglishLoader) {
                              callVocAI("english");
                            }
                          }}
                          onChange={(d) => {
                            handleAddVocData(
                              "word",
                              d.target.value.trimStart()
                            );
                          }}
                          placeholder="Word English"
                          autoSize
                          autoFocus
                          style={{
                            backgroundColor: "transparent",
                            borderColor: "transparent",
                            color: "white",
                            fontWeight: 200,
                          }}
                        />
                        <div style={{ position: "absolute", top: 6, right: 4 }}>
                          {showWordEnglishLoader ? (
                            <Loading size={17} />
                          ) : (
                            <EnterOutlined
                              disabled={showWordEnglishLoader}
                              onClick={() => {
                                if (!showWordEnglishLoader) {
                                  callVocAI();
                                }
                              }}
                              style={{ fontSize: "25px" }}
                            />
                          )}
                        </div>
                      </div>
                    ) : (
                      <>
                        <TextReader
                          stopAudio={stopAudio}
                          text={get(data, "word_english", "")}
                          language={"en-US"}
                          style={{ float: "right" }}
                        />

                        <TextArea
                          disabled={
                            value?.created_by === "owe_admin" ||
                            currentUser?.role === "student" ||
                            value?.created_by === "teacher" ||
                            tabSelector?.type === "my_student_cog"
                          }
                          value={get(data, "word_english", "")}
                          onChange={(d) =>
                            editDataProperty(
                              value.id,
                              d.target.value.trimStart(),
                              "word_english"
                            )
                          }
                          placeholder="Word English"
                          autoSize
                          autoFocus
                          style={{
                            width: 150,
                            backgroundColor: "transparent",
                            borderColor: "transparent",
                            color: "white",
                            fontWeight: 200,
                          }}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <TextReader
                      stopAudio={stopAudio}
                      text={get(data, "word_english", "")}
                      language={"en-US"}
                      style={{ float: "right" }}
                    />

                    <TextArea
                      onBlur={() => {
                        handleUpdateData(value, "word_english", prevValueRef);
                      }}
                      onFocus={() => handleFocus(get(data, "word_english", ""))}
                      disabled={disbledInput(
                        value?.created_by,
                        data?.word_spanish
                      ) || !isCognatesAllowedForBookGroup}
                      value={get(data, "word_english", "")}
                      onChange={(d) =>
                        editDataProperty(
                          value.id,
                          d.target.value.trimStart(),
                          "word_english"
                        )
                      }
                      autoSize
                      style={{
                        backgroundColor: "transparent",
                        borderColor: "transparent",
                        color: "white",
                        fontWeight: 200,
                        padding: 0,
                      }}
                    />
                  </>
                )}
              </td>

              {/*  *** for  type **** */}
              <td style={{ textAlign: "center" }}>
                {data?.word_spanish && (
                  <TextArea
                    disabled={true}
                    value={data?.type ? "True Cognate" : "False Cognate"}
                    autoSize
                    style={{
                      backgroundColor: "transparent",
                      borderColor: "transparent",
                      color: "white",
                      fontWeight: 200,
                      padding: 0,
                    }}
                  />
                )}
              </td>

              {/*  *** for  Explanation **** */}
              <td style={{ textAlign: "center" }}>
                <TextReader
                  stopAudio={stopAudio}
                  text={get(data, "explaination", "")}
                  language={"es-ES"}
                  style={{ float: "right" }}
                />

                <TextArea
                  onBlur={() => {
                    handleUpdateData(value, "explaination", prevValueRef);
                  }}
                  onFocus={() => handleFocus(get(data, "explaination", ""))}
                  disabled={(disbledInput(value?.created_by, data?.word_spanish) || !isCognatesAllowedForBookGroup)}
                  value={get(data, "explaination", "")}
                  onChange={(d) =>
                    editDataProperty(
                      value.id,
                      d.target.value.trimStart(),
                      "explaination"
                    )
                  }
                  autoSize
                  style={{
                    width: "200px",
                    backgroundColor: "transparent",
                    borderColor: "transparent",
                    color: "white",
                    fontWeight: 200,
                    padding: "0px",
                    height: "133.6px",
                    resize: "none",
                    marginTop: "12px",
                  }}
                />
              </td>

              {/*  *** for  sentence in spanish **** */}
              <td style={{ textAlign: "center" }}>
                <TextReader
                  stopAudio={stopAudio}
                  text={get(data, "sentence_spanish", "")}
                  language={"es-ES"}
                  style={{ float: "right" }}
                />

                <TextArea
                  onBlur={() => {
                    handleUpdateData(value, "sentence_spanish", prevValueRef);
                  }}
                  onFocus={() => handleFocus(get(data, "sentence_spanish", ""))}
                  disabled={(disbledInput(value?.created_by, data?.word_spanish) || !isCognatesAllowedForBookGroup)}
                  value={get(data, "sentence_spanish", "")}
                  onChange={(d) =>
                    editDataProperty(
                      value.id,
                      d.target.value.trimStart(),
                      "sentence_spanish"
                    )
                  }
                  autoSize
                  style={{
                    backgroundColor: "transparent",
                    borderColor: "transparent",
                    color: "white",
                    fontWeight: 200,
                    padding: 0,
                    marginTop: "12px",
                  }}
                />
              </td>

              {/*  *** for  sentence in english **** */}
              <td style={{ textAlign: "center" }}>
                <TextReader
                  stopAudio={stopAudio}
                  text={get(data, "sentence_english", "")}
                  language={"en-US"}
                  style={{ float: "right" }}
                />

                <TextArea
                  onBlur={() => {
                    handleUpdateData(value, "sentence_english", prevValueRef);
                  }}
                  onFocus={() => handleFocus(get(data, "sentence_english", ""))}
                  disabled={(disbledInput(value?.created_by, data?.word_spanish) || !isCognatesAllowedForBookGroup)}
                  value={get(data, "sentence_english", "")}
                  onChange={(d) =>
                    editDataProperty(
                      value.id,
                      d.target.value.trimStart(),
                      "sentence_english"
                    )
                  }
                  autoSize
                  style={{
                    backgroundColor: "transparent",
                    borderColor: "transparent",
                    color: "white",
                    fontWeight: 200,
                    padding: 0,
                    marginTop: "12px",
                  }}
                />
              </td>

              {/*  *** for  action **** */}
              <td style={{ textAlign: "center" }}>
                {get(currentUser, "role") === "student" &&
                  data?.word_spanish && (
                    <>
                      {value?.created_by !== "student" ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <ActionText>
                            {value?.created_by === "owe_admin"
                              ? "Admin"
                              : "Teacher"}
                          </ActionText>
                        </div>
                      ) : (
                        <>
                        {isCognatesAllowedForBookGroup && (
                        <Delete
                          style={{ fontSize: 20 }}
                          onClick={() => {
                            setLoading({
                              type: "delete",
                              value: false,
                              selectedData: value,
                            });
                            setDeleteModal(true);
                          }}
                        />
                      )}
                      </>
                      )}
                    </>
                  )}

                {get(currentUser, "role") === "teacher" &&
                  data?.word_spanish && (
                    <>
                      {value?.created_by === "owe_admin" ? (
                        <ActionText>
                          {value?.created_by === "owe_admin"
                            ? "Admin"
                            : "Teacher"}
                        </ActionText>
                      ) : tabSelector?.type === "my_student_cog" ? (
                        <ActionText>
                          {tabSelector?.type === "my_student_cog"
                            ? "Student"
                            : ""}
                        </ActionText>
                      ) : (
                        <Delete
                          style={{ fontSize: 20 }}
                          onClick={() => {
                            setLoading({
                              type: "delete",
                              value: false,
                              selectedData: value,
                            });
                            setDeleteModal(true);
                          }}
                        />
                      )}
                    </>
                  )}

                {get(currentUser, "role") === "owe_admin" &&
                  data?.word_spanish && (
                    <Delete
                      style={{ fontSize: 20 }}
                      onClick={() => {
                        setLoading({
                          type: "delete",
                          value: false,
                          selectedData: value,
                        });
                        setDeleteModal(true);
                      }}
                    />
                  )}
              </td>
            </tr>
          );
        })}
        {tabSelector?.type !== "my_student_cog" && (
            <>
              {currentUser?.role === "student" &&
              tabSelector?.type === "congantes" ? null : (
                <tr className="vocabulHeadTr">
                  <td></td>
                  <td>
                    {tabSelector?.type !== "my_student_cog" && tabSelector?.type !== "unit_cognates" && !is_cognet_block_edit && isCognatesAllowedForBookGroup && (
                      <IconButton
                        onClick={() => {
                          if (handleForDistrictAdmin()) return;
                          if (handleAIBeforeAddNewItem()) return;
                          addNewItem();
                        }}
                      >
                        <Add style={{ fontSize: "18px" }} />
                      </IconButton>
                    )}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              )}
            </>
          )}
          
               {vocLoader ? (
                  <Loading size={28} style={{ color: '#022b70' }} />
                ) : 
                <>
                  {getBooksVocab?.length === 0 && (
                   <tr>
                    <td colSpan={12} style={{ border: 'none' }}>
                      <p style={{ fontWeight: 200, paddingTop: "5px", display: "flex", justifyContent: "center" }}>
                        No Cognates available in this section.
                      </p>
                    </td>
                   </tr>
                  )}
                </>
               }
        <tfoot>
          <tr>
            <td colspan="9">
            {selectedModeDataLength > itemsPerPage && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', padding: '15px',backgroundColor:"#393939", width:"100%" }}>
          <IconButton 
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
            size="small"
            style={{ color: 'white' }}
          >
            <ChevronLeft />
          </IconButton>
          <span style={{ color: 'white', fontSize: '14px', minWidth: '150px', textAlign: 'center' }}>
            Page {currentPage} of {Math.ceil(selectedModeData.length / itemsPerPage)} ({selectedModeData.length} items)
          </span>
          <IconButton 
            disabled={currentPage >= Math.ceil(selectedModeData.length / itemsPerPage)}
            onClick={() => setCurrentPage(prev => Math.min(Math.ceil(selectedModeData.length / itemsPerPage), prev + 1))}
            size="small"
            style={{ color: 'white' }}
          >
            <ChevronRight />
          </IconButton>
        </div>
      )}
              
            </td>
          </tr>
  </tfoot>
          
      </StyledTable>
      
    </>
  );
};

export default CogantesTable;

const ActionText = styled.p`
  font-size: 14px;
  color: white;
  font-weight: 500;
`;

const StyledTable = styled.table`
  width: 100%;
  overflow-y: auto;
  max-height: 550px;
  border-collapse: collapse;
  td {
    border: 0.5px solid #fff;
  }
  th {
    border: 0.5px solid #fff;
  }
`;

const StyledHeader = styled.tr`
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
`;
const StyledTh = styled.th`
  background: #5d4187;
  color: #ffffff;
`;
